module.exports = __webpack_public_path__ + "img/favicon.0392bb78.png";